<script setup lang="ts">
import {ref} from "vue";
import {useClipboard} from "@vueuse/core";

interface Props {
    text: string
}
const props = defineProps<Props>()
const emit = defineEmits(['copied'])
const { copy, isSupported } = useClipboard()
const isShown = ref(false)
const randomId = Math.random().toString(36).substring(7)

const copyToClipboard = () => {
    copy(props.text)
    isShown.value = true
    emit('copied')
    setTimeout(() => {
        isShown.value = false
    }, 3000)
}
</script>

<template>
    <v-tooltip
        v-if="isSupported"
        :model-value="true"
        location="end"
        :activator="`#copy-btn-${randomId}`"
        offset="5"
        :class="isShown ? null : 'hidden'"
    >
        <template #activator>
            <default-btn
                :id="`copy-btn-${randomId}`"
                :color="isShown ? 'success' : 'primary'"
                size="small"
                class="text-body-2 font-weight-medium border bg-transparent border-e-0"
                variant="plain"
                :rounded="true"
                icon="mdi-clipboard-arrow-left-outline"
                @click="copyToClipboard"
            >
                <v-icon
                    color="primary"
                >
                    mdi-clipboard-arrow-left-outline
                </v-icon>
            </default-btn>
        </template>
        Copied!
    </v-tooltip>
</template>

<style scoped>
.hidden {
    display: none;
}
</style>
